import type { PlatformBridge } from './PlatformBridge';

// TWA host (Trusted Web Activity via Bubblewrap). Paid-app model: no ads, no in-app purchases.
export const androidBridge: PlatformBridge = {
  platform: 'android',
};
